import React from 'react'
import { Tooltip } from '@mui/material'
import SharedStatusBadge from '../../shared/StatusBadge'
import { t } from '../../../i18n'
import { OrderRowVoucher } from '../types'

const scope = 'orders.voucher'

// How long a tapped tooltip stays up on touch, where there is no pointer to hover away.
export const TOOLTIP_TOUCH_LINGER_MS = 4000

const issuerLabel = ({ initiator, issued_by }: OrderRowVoucher): string => {
  if (initiator === 'staff' && issued_by)
    return t('issued_by_user', { scope, name: issued_by })
  if (initiator === 'staff') return t('issued_by_staff', { scope })
  if (initiator === 'customer') return t('issued_by_customer', { scope })

  return t('issued_by_system', { scope })
}

const tooltipText = (voucher: OrderRowVoucher): string => {
  const issuer = issuerLabel(voucher)
  if (voucher.status === 'active') return issuer

  return `${issuer} \u00b7 ${t(`statuses.${voucher.status}`, { scope })}`
}

const VoucherBadge = ({
  voucher
}: {
  voucher: OrderRowVoucher | null | undefined
}) => {
  if (!voucher) return null

  const badge = (
    <SharedStatusBadge label={t('badge', { scope })} variant="info-outline" />
  )

  return (
    <Tooltip
      title={tooltipText(voucher)}
      enterTouchDelay={0}
      leaveTouchDelay={TOOLTIP_TOUCH_LINGER_MS}
    >
      {voucher.url ? (
        <a
          href={voucher.url}
          target="_blank"
          rel="noopener noreferrer"
          className="status-cell__voucher status-cell__voucher--link"
        >
          {badge}
        </a>
      ) : (
        <span tabIndex={0} className="status-cell__voucher">
          {badge}
        </span>
      )}
    </Tooltip>
  )
}

export default VoucherBadge
